// *https://www.registers.service.gov.uk/registers/country/use-the-api*
// import fetch from 'cross-fetch';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import {apiPathConfig} from "../utils/config";
import {fetchJson as httpClient} from "../utils/keycloak";
import get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  noneColorInput: {},
  greenInput: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'green',
      },
      '&:hover fieldset': {
        borderColor: 'darkgreen',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'green',
      },
      color: 'green', // цвет текста
    },
    /*'& .MuiInputLabel-outlined': {
      color: 'green', // цвет лейбла
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: 'green',
    },*/
  },
}));

export default function Asynchronous2(props) {
    const {
        resultStart = null,
        sort=null,
        multiple = false,
        error = false,
        value = null,
        setValue,
        //defaultValue,
        choices = null,
        url = '',
        filter = '',
        getOptionLabel,
        label = '---',
        outputField = '',
        searchField = 'search',
        domain = apiPathConfig.getApiUrl(),
        nameForFilter = '',
        winWidth = null,
        limit= 15,
        highlightBorder = false,
    } = props

    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [valueTyping, setValueTyping] = React.useState('');
    const [options, setOptions] = React.useState(choices ? choices : []);
    const [optionsFilters, setOptionsFilters] = React.useState(choices ? choices : []);
    const [loading, setLoading] = React.useState(false);
    // const loading = open && options.length === 0;

    // const domain = apiPathConfig.getApiUrl()
    const fetchQuery = `${domain}${url}?limit=${limit}&ordering=${sort ? sort : '-id'}&skip=0${filter}`

    const handleChange = (event) => {
        // console.log('VALUE TYPING =======>', event.target.value)
        setValueTyping(event.target.value)
        // debugger
    }
    const handleChangeA = (event, newInputValue) => {
        //console.log('newInputValue======>', newInputValue)
        let res = null
        if (newInputValue) {
            if (outputField) res = get(newInputValue, outputField, null)
            else res = newInputValue
        }
        setValue(res)
        /*if (newInputValue && newInputValue[outputField] !== undefined) setValue(newInputValue[outputField])
        else setValue(null)*/
    }

    React.useEffect(() => {
        // console.log('value===!!!====>', value)
        setValueTyping('')
    }, [value]); // eslint-disable-line

    React.useEffect(() => {
        // console.log('value===!!!====>', value)
        // if(value) setValueTyping('')
        if (multiple && value) {
            let val = value.map((it) => it.id)
            let opt = options.filter(x => val.indexOf(x.id) < 0)
            setOptionsFilters(opt)
        } else setOptionsFilters(options)
    }, [options, value]); // eslint-disable-line

    React.useEffect(() => {
        if (choices) setOptions(choices)
    }, [choices]); // eslint-disable-line

    React.useEffect(() => {
        // console.log(searchField,'valueTyping===!!!====>', valueTyping)
        if (choices === null) {
            (async () => {
                setLoading(true)
                const response = await httpClient(`${fetchQuery}&${searchField}=${valueTyping}`);
                // await sleep(1e3); // For demo purposes.
                const res = response.json;

                let results
                if(resultStart) results = [resultStart, ...res.results];
                else results = res.results
                // debugger
                // console.log('results !!! =======>', results)
                setOptions(Object.keys(results).map((key) => results[key]));
                setLoading(false)
            })();
        } else {
            /*if(valueTyping.length > 0)
                setOptionsFilters(optionsFilters.filter(x => x.name.toUpperCase().indexOf(valueTyping.toUpperCase()) >= 0 ))
            else setOptionsFilters(options)*/
            if (valueTyping.length > 0)
                setOptions(choices.filter(x => x.name.toUpperCase().indexOf(valueTyping.toUpperCase()) >= 0))
            else setOptions(choices)
        }
    }, [setLoading, fetchQuery, valueTyping, searchField]);

    // React.useEffect(() => {
    //     if (!open) {
    //         setOptions([]);
    //     }
    // }, [open]);

    return (
        <Autocomplete
            multiple={multiple}
            value={value}
            //defaultValue={defaultValue}
            id={`${url}-id-autocomplete`}
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            // getOptionSelected={(option, value) => option.name === value.name}
            getOptionLabel={getOptionLabel}
            // options={options}
            options={optionsFilters}
            filterOptions={(option, {inputValue}) => {//Берет, все что пришло, не применяя фильтр
                if (nameForFilter) {
                    return option.filter(x => x[nameForFilter].toUpperCase().indexOf(inputValue.toUpperCase()) >= 0)
                }
                return option
            }}
            onChange={handleChangeA}
            // onSelect={handleChangeA}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    error={error}
                    value={valueTyping}
                    onChange={handleChange}
                    onBlur={(event) => {
                        setValueTyping('')
                    }}
                    size={"small"}
                    label={label}
                    variant="outlined"
                    multiline
                    style={{
                        maxWidth: winWidth && winWidth
                    }}
                    className={value && highlightBorder ? classes.greenInput : classes.noneColorInput}
                    InputProps={{
                        ...params.InputProps,
                        //style: {padding: "0px"},
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}